export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M20.3 20.41a9.83 9.83 0 100-19.66 9.83 9.83 0 000 19.66zm2.46 19.67l-2.12-2.12a7.37 7.37 0 01.05-10.47l2.07-2.01c-.96-.1-1.68-.15-2.46-.15-6.57 0-19.67 3.3-19.67 9.83v4.92h22.13zm6.03-1.19c.96.96 2.53.96 3.49 0l12.64-12.73c.93-.93.93-2.46 0-3.42l-.03-.02a2.45 2.45 0 00-3.46 0l-10.9 10.96-3.36-3.36a2.42 2.42 0 00-3.44 0l-.03.02a2.43 2.43 0 000 3.42l5.09 5.13z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "46",
    "height": "41",
    "viewBox": "0 0 46 41"
  }
};